import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {
  Button,
  IconButton,
  TextField,
  Checkbox,
  Tooltip,
} from "@mui/material";
import CheckboxTick from "assets/CheckboxTick.svg";
import Checkbox2 from "assets/Checkbox2.svg";
import SubModuleIcon from "assets/submoduleIcon";
import EditIcon from "@mui/icons-material/Edit";
import { SnackbarContext } from "context/snackBarContext";
import CloseIcon from "assets/closeIcon.svg";
import "./Questionnare.css";
import WarningModal from "../../../utils/WarningModal";
import { ReactComponent as Warning } from 'assets/Warning.svg'; 
  const transparentDisabledStyle = {
    '& .MuiOutlinedInput-root': {
    '&.Mui-disabled': {
      '& fieldset': {
        borderColor: 'rgba(0, 0, 0, 0)',
        '&:hover': {
          borderColor: 'rgba(0, 0, 0, 0)',
        },
      },
    },
  },
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "75%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: "20px",
  height: "80vh", // Changed from 80vh to 70vh
  display: "flex",
  flexDirection: "column",
};

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  height: "100%", // Take full height of parent
  gap: "1rem", // Reduced gap from 1rem to 0.5rem for tighter spacing
};

const generateResponseCode = (questionCode, sequence) => {
  if (!questionCode) return "";
  try {
    // Split the question code by underscore
    const parts = questionCode.split("_");
    
    // Get first two characters of first part
    const firstPart = parts[0]?.substring(0, 2) || "";

    // Get first character of second part
    const secondPart = parts[1]?.substring(0, 1) || "";

    // Get number from third part, adding leading zero only for single digits
    const thirdPartNum = parseInt(parts[2] || "0", 10);
    const thirdPart = thirdPartNum < 10 ? `0${thirdPartNum}` : thirdPartNum.toString();
   
    // Combine parts and add response sequence with leading zero only for single digits
    const baseCode = `${firstPart}${secondPart}${thirdPart}`;
    const formattedSequence = sequence < 10 ? `0${sequence}` : sequence.toString();
    return `${baseCode}_R${formattedSequence}`;
  } catch (error) {
    console.error("Error generating response code:", error);
    const fallbackSequence = sequence < 10 ? `0${sequence}` : sequence.toString();
    return `RC${fallbackSequence}`;
  }
};

let alertQuestionCodes = [
  "CD_EN_002",
  "CD_EN_006",
  "CD_EN_004",
  "CD_EN_005",
  "CD_EN_008",
  "CD_EN_009",
  "CF_EN_008",
  "CF_EN_009",
  "CF_EN_011",
  "CF_EN_012",
  "CF_EN_019",
  "CF_EN_020",
  "CF_EN_022",
  "CF_EN_023",
  "HP_EN_002",
  "PC_EN_023",
  "PC_EN_024",
  "PC_EN_025",
  "PC_EN_026",
  "PC_EN_027",
  "HP_EN_011",
  "PC_FC_019",
  "SE_EN_006",
  "HP_EN_012",
  "HP_SO_063",
  "HP_SO_064",
  "PC_EN_002",
  "SE_EN_005",
  "VC_SO_019",
  "VC_SO_022",
  "WO_SO_025",
  "VC_SO_003",
  "VC_SO_005",
  "VC_SO_007",
  "VC_SO_009",
  "VC_SO_011",
  "VC_SO_013",
  "WO_SO_009",
  "WO_SO_011",
  "WO_SO_013",
  "WO_SO_015",
  "WO_SO_017",
  "WO_SO_019",
  "HP_SO_029",
  "PC_SO_013",
  "VC_SO_017",
  "WO_SO_023",
  "VC_SO_021",
  "VC_SO_024",
  "WO_SO_006",
  "WO_SO_027",
];
// Add new validation modal component
const ValidationModal = ({ open, onClose, onConfirm }) => {
  return (
   <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="validation-modal-title"
      aria-describedby="validation-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '40px 10px',
          maxWidth: '500px',
          width: '90%',
          textAlign: 'center',
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
          outline: 'none'
        }}
      >
        {/* Failed Icon */}
        
          <Box sx={{ mb: 0 }}>
          <Warning style={{ width: '161px', height: '149px', margin: '0 auto' }} />
        </Box>

        {/* Warning Message */}
        <Typography
          id="validation-modal-description"
          sx={{
            color: '#333',
            fontSize: '16px',
            lineHeight: 1.5,
            fontFamily:'Montserrat',
            fontWeight:500,
            mb: 4,
            maxWidth: '400px',
             margin: '0 auto'
          }}
        >
         "Please select at least one option as active"
        </Typography>

        {/* OK Button */}
        <Button
          onClick={onConfirm}
          sx={{
            mt:4,
            backgroundColor: '#EF7D00',
            color: 'white',
            borderRadius: '10px',
            padding: '12px 32px',
            fontSize: '16px',
            fontWeight: 'bold',
            minWidth: '100px',
            '&:hover': {
              backgroundColor: '#d66d00'
            },
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
          }}
        >
          OK
        </Button>
      </Box>
    </Modal>
  );
};
export default function DropdownModal(props) {
  const [loading, setLoading] = React.useState(false);
  const [editRowId, setEditRowId] = React.useState(null);
  const [editValue, setEditValue] = React.useState("");
  const [fieldName, setFieldName] = React.useState("");
  const [openWarningModal, setOpenWarningModal] = React.useState(false);
  const [editTranslationValue, setEditTranslationValue] = React.useState("");
  const [selectAll, setSelectAll] = React.useState(false);
  const [openValidationModal, setOpenValidationModal] = React.useState(false);
  const { setOpenAlert, setSeverity, setMessage } =
    React.useContext(SnackbarContext);
 // Validation function for local users
  const validateLocalUserSelection = () => {
    if (props.isGlobalUser) return true;
    
    const hasActiveOrMandatory = props.modalRows?.some(row => 
      row.isActive || row.isMandatory || row.stMandatory === "M"
    );
    
    return hasActiveOrMandatory;
  };

  // Handle validation modal confirmation
  const handleValidationConfirm = () => {
    setOpenValidationModal(false);
    // Don't close the main modal, just dismiss the validation modal
  };
     


  const onNext = () => {
    // Your onNext logic here
  };
  
  const onDragEnd = (result) => {
    if (
      props.mode === "View" ||
      props.mode === "newView" ||
      !result.destination
    )
      return;

    const items = Array.from(props?.modalRows);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    // Update display sequence while preserving original sequence and response code
    const updatedItems = items.map((item, index) => {
      // Ensure originalSeq exists or use the initial seq value
      const originalSeq = item.originalSeq || item.seq;
      return {
        ...item,
        seq: index + 1, // Update display sequence
        originalSeq: originalSeq, // Keep original sequence
        // responseCode: item.responseCode || generateResponseCode(props?.questionCode, originalSeq)
        responseCode: item.responseCode,
      };
    });

    props.setModalRows(updatedItems);
  };

  const handleEditClick = (row) => {
    setEditRowId(row.hlcId);
    if (props.mode === "View" || props.mode === "newView") {
      if (
        alertQuestionCodes.includes(props?.questionCode) &&
        props?.deactivateWarningModal == true
      ) {
        setOpenWarningModal(true);
      }
      setEditTranslationValue(row.stResponseLL || "");
    } else {
      setEditValue(row.name);
    }
  };

  const handleInputChange = (e) => {
    setEditValue(e.target.value);
  };

  const handlePriorityChange = (hlcId) => {
    const updatedRows = props.modalRows.map((row) => {
      if (row.hlcId === hlcId) {
        // Toggle current row
        return { ...row, isPriority: !row.isPriority };
      } else {
        // Deselect all other rows
        return { ...row, isPriority: false };
      }
    });

    props.setModalRows(updatedRows);
  };

  const priorityRow = props?.modalRows?.find((row) => row.isPriority);

  const handleSaveClick = () => {
    const updatedRows = props?.modalRows.map((row) =>
      row.hlcId === editRowId
        ? {
            ...row,
            ...(props.mode === "View"
              ? { stResponseLL: editTranslationValue }
              : {
                  name: editValue,
                  responseCode:
                    row.responseCode ||
                    generateResponseCode(
                      props?.questionCode,
                      row.originalSeq || row.seq
                    ),
                    //stMandatory: row.isMandatory ? "M" : (row.isActive ? "A" : null)
                }),
          }
        : row
    );

    // Update the parent component's state with new rows including translations
    props.setModalRows(updatedRows);
    setEditRowId(null);
    setEditValue("");
    setEditTranslationValue("");
  };

  const handleCancelClick = () => {
    setEditRowId(null);
    setEditValue("");
    setEditTranslationValue("");
  };

  

  // Update handleTranslationChange to immediately update modalRows
  const handleTranslationChange = (hlcId, value) => {
    setEditTranslationValue(value);

    // Immediately update the stResponseLL in modalRows
    const updatedRows = props?.modalRows.map((row) =>
      row.hlcId === hlcId
        ? {
            ...row,
            stResponseLL: value,
          }
        : row
    );
    props.setModalRows(updatedRows);
  };

  // const handleClose = () => {
  //   props?.setDeactivateWarningModal();
  //   setOpenWarningModal(false);
  // };
   // Enhanced close handler with validation
  const handleClose = () => {
  // Only validate for local users when actually closing the modal
  if (!props.isGlobalUser && !validateLocalUserSelection()) {
    setOpenValidationModal(true);
    return; // Don't close the modal
  }
  
  // Handle warning modal closure if it's open
  if (openWarningModal) {
    props?.setDeactivateWarningModal();
    setOpenWarningModal(false);
    return; // Don't close the main modal, just the warning modal
  }
  
  // Close the main modal
  resetEditState();
  props.onClose();
};
  React.useEffect(() => {
    if (!props.open) {
      resetEditState();
    }
  }, [props.open]);

  const resetEditState = () => {
    setEditRowId(null);
    setEditValue("");
    setEditTranslationValue("");
  };


const onAdd = () => {
    let modalRowNew = [...props?.modalRows];
    if (fieldName == "" || fieldName == undefined) {
      setMessage(`Please enter name`);
      setSeverity("error");
      setOpenAlert(true);
      return;
    }

    const newSeq = modalRowNew.length + 1;
    let Obj = {
      name: fieldName,
      id: modalRowNew.length,
      hlcId: modalRowNew.length,
      seq: newSeq,
      originalSeq: newSeq,
      isPriority: false,
      stResponseLL: "",
      responseCode: generateResponseCode(props?.questionCode, newSeq),
      isMandatory: props.isGlobalUser,
      isActive: false,
      stMandatory: props.isGlobalUser?"M":null
    };
    modalRowNew.push(Obj);
    props.setModalRows(modalRowNew);
    setFieldName("");
};

React.useEffect(() => {
    if (props.modalRows && props.modalRows.length > 0) {
      const allMandatory = props.modalRows.every(row => row.isMandatory);
      setSelectAll(allMandatory);
    }
}, [props.modalRows]);

// Updated handleMandatoryChange for Global users
const handleMandatoryChange = (hlcId) => {
  const updatedRows = props.modalRows.map((row) => {
    if (row.hlcId === hlcId) {
      const newMandatory = !row.isMandatory;
      return {
        ...row,
        isMandatory: newMandatory,
        stMandatory: newMandatory ? "M" : null,
      };
    }
    return row;
  });

  props.setModalRows(updatedRows);

  const allMandatory = updatedRows.every(row => row.isMandatory);
  setSelectAll(allMandatory);
};

// Updated handleSelectAllMandatory for Global users
const handleSelectAllMandatory = () => {
  const newSelectAll = !selectAll;
  setSelectAll(newSelectAll);

  const updatedRows = props.modalRows.map((row) => ({
    ...row,
    isMandatory: newSelectAll,
    stMandatory: newSelectAll ? "M" : null,
  }));

  props.setModalRows(updatedRows);
};

// Updated handleActiveChange for Local users
const handleActiveChange = (hlcId) => {
  const updatedRows = props.modalRows.map((row) => {
    if (row.hlcId === hlcId) {
      // Don't allow changes if this row was marked as mandatory by Global user
      if (row.stMandatory === "M") {
        return row; // Return unchanged
      }
      
      const newActive = !row.isActive;
      return {
        ...row,
        isActive: newActive,
        stMandatory: newActive ? "A" : null,
      };
    }
    return row;
  });

  props.setModalRows(updatedRows);
};

// Helper function to determine if a row should be disabled for Local users
const isRowDisabledForLocal = (row) => {
  return !props.isGlobalUser && row.stMandatory === "M";
};

// Helper function to determine checkbox state for Local users
const getLocalCheckboxState = (row) => {
  if (props.isGlobalUser) return row.isMandatory || false;
  
  // For Local users: if Global marked as mandatory, show as active and checked
  if (row.stMandatory === "M") return true;
  
  return row.isActive || false;
};


  return (
    <div>
    <ValidationModal
        open={openValidationModal}
        onClose={() => setOpenValidationModal(false)}
        onConfirm={handleValidationConfirm}
      />
      <WarningModal
        open={openWarningModal}
        onClose={() => handleClose()}
        message={`All the answers available in this question are also available in other questions. In case you change the translation, please make sure to check other questions if it is necessary to change translations too.`}
      />
      <Modal
        open={props.open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <IconButton
  onClick={handleClose} // Change this from the inline function to handleClose
  sx={{
    position: "absolute",
    top: 4,
    right: 2,
  }}
>
  <img src={CloseIcon} alt="closeIcon" />
</IconButton>

          <Box sx={containerStyle}>
            <div
              className="table-container"
              style={{
                flexGrow: 1,
                overflowY: "auto",
                marginBottom: "20px",
              }}
            >
              <DragDropContext onDragEnd={onDragEnd}>
                <table className="full-width-table-question-dropdown">
                  <thead>
                    <tr>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          paddingLeft: "0px",
                          height: "48px",
                        }}
                      >
                        <Box
                          sx={{
                            width: "100%",
                            justifyContent: "left",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <th
                            style={{
                              textAlign: "left",
                              paddingLeft: "20px",
                              color: "#103367",
                              fontFamily: "Montserrat",
                              fontWeight: 600, // Changed from 500
                              fontSize: "16px", // Added font size
                            }}
                          ></th>
                          <th
                            style={{
                              textAlign: "left",
                              paddingLeft: "0px",
                              color: "#103367",
                              fontFamily: "Montserrat",
                              fontWeight: 600, // Changed from 500
                              fontSize: "16px", // Added font size
                              userSelect: props.mode === "newView" ? "none" : "auto"
                            }}
                          >
                            Response Code
                          </th>
                        </Box>
                        <Box
                          sx={{
                            width: "100%",
                            justifyContent: "center",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <th
                            style={{
                              textAlign: "center",
                              color: "#103367",
                              fontFamily: "Montserrat",
                              fontWeight: 600, // Changed from 500
                              fontSize: "16px", // Added font size
                              userSelect: props.mode === "newView" ? "none" : "auto",
                            }}
                          >
                            Response
                          </th>
                        </Box>
                        {(props.mode === "View" ||
                          props.mode === "newView") && (
                            <Box
                              sx={{
                                width: "100%",
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <th
                                style={{
                                  textAlign: "center",
                                  color: "#103367",
                                  fontFamily: "Montserrat",
                                  fontWeight: 600, // Changed from 500
                                  fontSize: "16px", // Added font size
                                  userSelect: props.mode === "newView" ? "none" : "auto",
                                }}
                              >
                                Response Translation
                              </th>
                            </Box>
                          )}
                          {props.isGlobalUser && (
                          <Box
                            sx={{
                              width: "100%",
                              justifyContent: "center",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <th
                              style={{
                                textAlign: "center",
                                color: "#103367",
                                fontFamily: "Montserrat",
                                fontWeight: 600,
                                fontSize: "16px",
                                userSelect: props.mode === "newView" ? "none" : "auto",
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                                <Checkbox
                                  checked={selectAll}
                                  disabled={props.mode === "newView"}
                                  onChange={handleSelectAllMandatory}
                                  icon={<img src={Checkbox2} alt="unchecked" />}
                                  checkedIcon={<img src={CheckboxTick} alt="checked" />}
                                  sx={{
                                    padding: 0,
                                    mr:2,
                                    "& .MuiSvgIcon-root": {
                                      backgroundColor: "transparent",
                                    },
                                  }}
                                />
                                <span>Select All</span>
                              </div>
                            </th>
                          </Box>
                        )}
                         {!props.isGlobalUser && (
                          <Box
                            sx={{
                              width: "100%",
                              justifyContent: "center",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <th
                              style={{
                                textAlign: "center",
                                color: "#103367",
                                fontFamily: "Montserrat",
                                fontWeight: 600,
                                fontSize: "16px",
                                userSelect: props.mode === "newView" ? "none" : "auto",
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                               
                                <span></span>
                              </div>
                            </th>
                          </Box>
                        )}
                        {props.desc === "Multi Select Dropdown" && (
                          <Box
                            sx={{
                              width: "100%",
                              justifyContent: "center",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <th
                              style={{
                                textAlign: "left", // Changed from center to left
                                paddingLeft: "20px",
                                color: "#103367",
                                fontFamily: "Montserrat",
                                fontWeight: 600, // Changed from 500
                                fontSize: "16px", // Added font size
                                userSelect: props.mode === "newView" ? "none" : "auto",
                              }}
                            >
                              Priority Response
                            </th>
                          </Box>
                        )}
                        <Box
                          sx={{
                            width: "100%",
                            justifyContent: "right",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <th
                            style={{
                              textAlign: "center",
                              color: "#103367",
                              fontFamily: "Montserrat",
                              fontWeight: 600, // Changed from 500
                              fontSize: "16px", // Added font size
                              paddingRight: "20px",
                              userSelect: props.mode === "newView" ? "none" : "auto",
                            }}
                          >
                            Action
                          </th>
                        </Box>
                      </Box>
                    </tr>
                  </thead>
                  <Droppable droppableId="rows" direction="vertical">
                    {(provided) => (
                      <tbody
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        {props?.modalRows &&
                          props?.modalRows.map((row, index) => (
                            <Draggable
                              key={row.hlcId}
                              draggableId={String(row.id)}
                              index={index}
                              isDragDisabled={
                                props.mode === "View" ||
                                props.mode === "newView"
                              }
                            >
                              {(provided, snapshot) => (
                                // <tr
                                //   ref={provided.innerRef}
                                //   {...provided.draggableProps}
                                //   {...provided.dragHandleProps}
                                //   className="hierarchyColumn"
                                //   style={{
                                //     ...provided.draggableProps.style,
                                //     height: "62px",
                                //     borderSpacing: snapshot.isDragging
                                //       ? "0px"
                                //       : "inherit",
                                //   }}
                                // >
                                <tr
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className="hierarchyColumn"
                                  style={{
                                    ...provided.draggableProps.style,
                                    borderSpacing: snapshot.isDragging
                                      ? "0px"
                                      : "inherit",
                                    cursor:
                                      props.mode === "View" ||
                                      props.mode === "newView"
                                        ? "default"
                                        : priorityRow &&
                                          row.hlcId !== priorityRow.hlcId
                                        ? "not-allowed"
                                        : "default",
                                    // pointerEvents:
                                    //   props.mode === "View" ? "none" : "auto", // Disable row actions in view mode
                                    // opacity: props.mode === "View" ? 0.5 : 1, // Dim rows in view mode
                                    userSelect:
                                      props.mode === "View" ||
                                      props.mode === "newView"
                                        ? "none"
                                        : priorityRow &&
                                          row.hlcId !== priorityRow.hlcId
                                        ? "none"
                                        : "auto",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      paddingLeft: "0px",
                                      height: "50px",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        width: "100%",
                                        justifyContent: "left",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <td
                                        style={{
                                          textAlign: "left",
                                          //   snapshot.isDragging ? "40%" : "1%",
                                        }}
                                      >
                                        <div style={{ paddingLeft: "20px" }}>
                                          <SubModuleIcon />
                                        </div>
                                      </td>
                                      <td>
                                        <Tooltip
                                          title={
                                            props.mode !== "Add"
                                              ? row.responseCode
                                              : row.responseCode ||
                                                generateResponseCode(
                                                  props?.questionCode,
                                                  row.originalSeq || row.seq
                                                )
                                          }
                                          placement="top-start"
                                          disableHoverListener={props.mode === "newView"}
                                          PopperProps={{
                                            modifiers: [
                                              {
                                                name: "offset",
                                                options: {
                                                  offset: [0, -10],
                                                },
                                              },
                                            ],
                                          }}
                                        >
                                          <TextField
                                            value={
                                              props.mode !== "Add"
                                                ? row.responseCode
                                                : row.responseCode ||
                                                  generateResponseCode(
                                                    props?.questionCode,
                                                    row.originalSeq || row.seq
                                                  )
                                            }
                                            variant="outlined"
                                            size="small"
                                            disabled
                                            sx={{
                                              width: "100%",
                                              "& .MuiInputBase-input": {
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              },
                                              "& .MuiInputBase-input.Mui-disabled":
                                                {
                                                  WebkitTextFillColor:
                                                    "#737D86",
                                                  fontFamily: "Montserrat",
                                                },
                                              "& .MuiOutlinedInput-root.Mui-disabled":
                                                {
                                                  "& > fieldset": {
                                                    borderColor: "#E0E0E0",
                                                  },
                                                },
                                               
                                             ...(props?.mode === "newView" ? transparentDisabledStyle : {}),
                                            }}
                                          />
                                        </Tooltip>
                                      </td>
                                    </Box>
                                    <Box
                                      sx={{
                                        width: "100%",
                                        justifyContent: "center",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <td
                                        style={{
                                          textAlign: "center",
                                          // width: "40%", // Changed from 55% to 40%
                                          //   snapshot.isDragging ? "10%" : "8%",
                                        }}
                                      >
                                        {editRowId === row.hlcId &&
                                        (props.mode !== "View" ||
                                          props.mode !== "newView")  && props.isGlobalUser  ? (
                                          <TextField
                                            value={editValue}
                                            onChange={handleInputChange}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            disabled={
                                              priorityRow &&
                                              row.hlcId !== priorityRow.hlcId
                                            }
                                          />
                                        ) : (
                                          <Tooltip
                                            title={row.name}
                                            placement="top-start"
                                            disableHoverListener={props.mode === "newView"}
                                          >
                                            <Typography
                                              sx={{
                                                maxWidth: "100%",
                                                display: "-webkit-box",
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                                lineHeight: "1.2em",
                                                maxHeight: "2.4em", // 2 lines * 1.2em line-height
                                                color: "#103367", // Added color
                                                fontSize: "16px", // Added font size
                                                fontWeight: 500, // Added font weight
                                                fontFamily: "Montserrat",
                                              }}
                                            >
                                              {row.name}
                                            </Typography>
                                          </Tooltip>
                                        )}
                                      </td>
                                    </Box>
                                    {(props.mode === "View" ||
                                      props.mode === "newView") && (
                                      <Box
                                        sx={{
                                          width: "100%",
                                          justifyContent: "left",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <td style={{ textAlign: "left" }}>
                                          {editRowId === row.hlcId ? (
                                            // Show editable TextField when row is being edited
                                            <TextField
                                              value={editTranslationValue} // Changed from row.stResponseLL to editTranslationValue
                                              onChange={(e) =>
                                                handleTranslationChange(
                                                  row.hlcId,
                                                  e.target.value
                                                )
                                              }
                                              variant="outlined"
                                              size="small"
                                              fullWidth
                                              // Remove priority check when in View mode
                                              disabled={
                                                props.mode !== "newView" &&
                                                props.mode !== "View" &&
                                                priorityRow &&
                                                row.hlcId !== priorityRow.hlcId
                                              }
                                              sx={{ ...(props?.mode === "newView" ? transparentDisabledStyle : {}),}}
                                            />
                                          ) : row.stResponseLL ? (
                                            // Show text when there's a stResponseLL value and row is not being edited
                                            <Tooltip
                                              title={row.stResponseLL}
                                              placement="top-start"
                                              disableHoverListener={props.mode === "newView"}
                                            >
                                              <Typography
                                                sx={{
                                                  maxWidth: "100%",
                                                  display: "-webkit-box",
                                                  WebkitLineClamp: 2,
                                                  WebkitBoxOrient: "vertical",
                                                  overflow: "hidden",
                                                  lineHeight: "1.2em",
                                                  maxHeight: "2.4em", // 2 lines * 1.2em line-height
                                                  color: "#103367", // Added color
                                                  fontSize: "16px", // Added font size
                                                  fontWeight: 500, // Added font weight
                                                  fontFamily: "Montserrat",
                                                }}
                                              >
                                                {row.stResponseLL}
                                              </Typography>
                                            </Tooltip>
                                          ) : (
                                            // Show disabled TextField when there's no stResponseLL value
                                            <TextField
                                              disabled
                                              variant="outlined"
                                              size="small"
                                              fullWidth
                                              placeholder="Type here.."
                                              sx={{
                                                "& .MuiInputBase-input.Mui-disabled":
                                                  {
                                                    WebkitTextFillColor:
                                                      "#737D86",
                                                    fontFamily: "Montserrat",
                                                    fontWeight: 500,
                                                  },
                                                "& .MuiOutlinedInput-root.Mui-disabled":
                                                  {
                                                    "& > fieldset": {
                                                      borderColor: "#E0E0E0",
                                                      fontWeight: 500,
                                                    },
                                                  },
                                                   ...(props?.mode === "newView" ? transparentDisabledStyle : {}),
                                              }}
                                            />
                                          )}
                                        </td>
                                      </Box>
                                    )}
                                    {props.isGlobalUser && (
  <Box sx={{ width: "100%", justifyContent: "center", display: "flex", alignItems: "center" }}>
    <td style={{ textAlign: "center" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
        <Checkbox
          checked={row.isMandatory || false}
          disabled={props.mode === "newView"}
          onChange={() => handleMandatoryChange(row.hlcId)}
          icon={<img src={Checkbox2} alt="unchecked" />}
          checkedIcon={<img src={CheckboxTick} alt="checked" />}
          sx={{
            padding: 0,
            "& .MuiSvgIcon-root": {
              backgroundColor: "transparent",
            },
          }}
        />
        <Typography sx={{
          color: "#737D86",
          fontSize: "14px",
          fontWeight: 500,
          fontFamily: "Montserrat",
          ml:2
        }}>
          Mandatory
        </Typography>
      </div>
    </td>
  </Box>
)}

{!(props.isGlobalUser) && (
  <Box sx={{ width: "100%", justifyContent: "center", display: "flex", alignItems: "center" }}>
    <td style={{ textAlign: "center" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
        <Checkbox
          checked={getLocalCheckboxState(row)}
          disabled={props.mode === "newView" || isRowDisabledForLocal(row)}
          onChange={() => handleActiveChange(row.hlcId)}
          icon={<img src={Checkbox2} alt="unchecked" />}
          checkedIcon={ row.stMandatory === "M"
      ? <img src={CheckboxTick} alt="mandatory checked" />
      : undefined
  }
          sx={{
            padding: 0,
            "& .MuiSvgIcon-root": {
              backgroundColor: "transparent",
            },
            // Add visual indication for disabled state
            opacity: isRowDisabledForLocal(row) ? 0.6 : 1,
          }}
        />
        <Typography sx={{
          color: "#737D86",
          fontSize: "14px",
          fontWeight: 500,
          fontFamily: "Montserrat",
          ml: 2,
          // Add visual indication for disabled state
          opacity: isRowDisabledForLocal(row) ? 0.6 : 1,
        }}>
          Active
        </Typography>
      </div>
    </td>
  </Box>
)}
                                    {props.desc === "Multi Select Dropdown" && (
                                      <Box
                                        sx={{
                                          width: "100%",
                                          justifyContent: "center",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <td
                                          style={{
                                            textAlign: "left", // Changed from center to left
                                            paddingLeft: "20px", // Added padding to align with header
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "8px", // Added consistent spacing
                                            }}
                                          >
                                            <Checkbox
                                              checked={row.isPriority || false}
                                              disabled={
                                                props.mode === "View" ||
                                                props.mode === "newView" ||
                                                (priorityRow &&
                                                  row.hlcId !==
                                                    priorityRow.hlcId)
                                              }
                                              onChange={() =>
                                                handlePriorityChange(row.hlcId)
                                              }
                                              icon={
                                                <img
                                                  src={Checkbox2}
                                                  alt="unchecked"
                                                />
                                              }
                                              checkedIcon={
                                                <img
                                                  src={CheckboxTick}
                                                  alt="checked"
                                                />
                                              }
                                              sx={{
                                                padding: 0,
                                                "& .MuiSvgIcon-root": {
                                                  backgroundColor:
                                                    "transparent",
                                                },
                                              }}
                                            />
                                          </div>
                                        </td>
                                      </Box>
                                    )}
                                    <Box
                                      sx={{
                                        width: "100%",
                                        justifyContent: "right",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <td
                                        style={{
                                          textAlign: "right",
                                          paddingRight: "20px",
                                        }}
                                      >
                                        {editRowId === row.hlcId ? (
                                          <>
                                            <Button
                                              sx={{
                                                margin: "2px",
                                                borderRadius: "12px",
                                                backgroundColor: "#112A63",
                                                borderColor: "#112A63",
                                                height: "2.125rem",
                                                color: "white",
                                                "&:hover": {
                                                  backgroundColor: "#112A63",
                                                  color: "white",
                                                  borderColor: "#112A63",
                                                },
                                              }}
                                              onClick={handleSaveClick}
                                            >
                                              Save
                                            </Button>
                                            <Button
                                              sx={{
                                                borderRadius: "12px",
                                                backgroundColor: "#737D86",
                                                borderColor: "#737D86",
                                                height: "2.125rem",
                                                color: "white",
                                                "&:hover": {
                                                  backgroundColor: "#737D86",
                                                  color: "white",
                                                  borderColor: "#737D86",
                                                },
                                              }}
                                              onClick={handleCancelClick}
                                            >
                                              Cancel
                                            </Button>
                                          </>
                                        ) : (
                                          <Button
                                            variant="outlined"
                                            sx={{
                                              borderRadius: "2.116rem",
                                              backgroundColor: "#FEF4D5",
                                              borderColor: "#F2BB40",
                                              height: "2.125rem",
                                              width: "4.938rem",
                                              color: "#F2BB40",
                                              "&:hover": {
                                                backgroundColor: "#F2BB40",
                                                color: "#FEF4D5",
                                                borderColor: "#F2BB40",
                                              },
                                            }}
                                            startIcon={<EditIcon />}
                                            onClick={() => handleEditClick(row)}
                                            disabled={
                                              props?.mode === "newView"
                                                ? true
                                                : props?.mode === "View"
                                                ? false
                                                : priorityRow &&
                                                  row.hlcId !==
                                                    priorityRow.hlcId
                                            }
                                          >
                                            Edit
                                          </Button>
                                        )}
                                      </td>
                                    </Box>
                                  </Box>
                                </tr>
                              )}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </tbody>
                    )}
                  </Droppable>
                </table>
              </DragDropContext>
            </div>

            {/* Fixed bottom section */}
            <div style={{ marginTop: "auto" }}>
              <TextField
                value={fieldName}
                fullWidth
                multiline
                rows={4} // Adjust the number of rows as needed
                onChange={(e) => {
                  setFieldName(e.target.value);
                }}
                disabled={props.mode === "View" || props.mode === "newView"}
                name="fieldName"
                placeholder="Type here.."
                variant="outlined"
                sx={{ 
                      userSelect: props?.mode === "newView" ? "none" : "text",
                      pointerEvents: props?.mode === "newView" ? "none" : "auto",
                      
                      ...(props?.mode === "newView" ? transparentDisabledStyle : {}),}}
              />

              <Box
                sx={{
                  mt: "20px",
                  justifyContent: "flex-end",
                  display: "flex",
                  gap: "1rem",
                }}
              >
                <Button
                  onClick={() => {
                    onAdd();
                  }}
                  disabled={props.mode === "View" || props.mode === "newView"}
                  style={{
                    backgroundColor:
                      props.mode === "View" || props.mode === "newView"
                        ? "#20376D"
                        : "#112A63",
                    fontWeight: 600,
                    width: "8.125rem",
                    height: "3.375rem",
                    borderRadius: "0.625rem",
                    color: "white",
                    opacity:
                      props.mode === "View" || props.mode === "newView"
                        ? 0.6
                        : 1,
                    cursor:
                      props.mode === "View" || props.mode === "newView"
                        ? "not-allowed"
                        : "pointer",
                  }}
                >
                  Add
                </Button>
              </Box>
            </div>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
